import styled from 'styled-components';

interface Props {
  isControl: boolean;
}

const GarageCardWrapper = styled.div`
  margin: 16px auto 0;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  border-radius: 8px;

  &:hover {
    cursor: pointer;
  }
  // For Tablets - devices less than 1024px
  @media (max-width: ${(props) => props.theme.breakpoint.lg}px) {
    margin: 16px 0 0;
  }
`;

const AlertHeader = styled.div`
  align-items: center;
  color: ${(props) => props.theme.color.primary.v600};
  border: 8px;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 16px;
  border-radius: 8px 8px 0 0;
  display: flex;

  // For Tablets and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    padding: 12px 16px;
  }
`;

const WarningHeader = styled(AlertHeader)`
  background: #fff5f5;
  span {
    margin-left: 4px;
  }
`;

const VehicleDetails = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 24px;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  max-width: 106px;
  height: 100%;
  height: 88px;
  overflow: hidden;
  border-radius: 4px;
  position: relative;
  background-color: #c4c4c4;

  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 284px;
    height: 148px;
  }
`;

const Image = styled.img`
  width: 106px;
  height: 88px;
  object-fit: cover;

  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    width: 284px;
    height: 148px;
  }
`;

const VehicleInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 16px;

  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding-left: 32px;
  }
`;

const Make = styled.h4`
  color: var(--cvna-color-blue-6);
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  text-transform: capitalize;
  margin: 0;

  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-weight: 700;
    font-size: 28px;
    line-height: 32px;
  }
`;

const Model = styled.h5`
  padding-top: 4px;
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: 0;

  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    padding-top: 8px;
  }
`;

const Price = styled.span`
  padding-top: 4px;
  color: ${(props) => props.theme.color.primary.v600};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;

  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-size: 20px;
    line-height: 24px;
    padding-top: 8px;
  }
`;

const PaymentSchedule = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: ${(props) => props.theme.color.neutral.v200};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.primary.v600};
  padding: 8px;
  margin: 0 16px 16px;

  & > svg {
    margin-right: 8px;
  }

  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    margin: -8px 24px 24px;
    padding: 8px 16px;
  }
`;

const RedirectLinkStyled = styled.button`
  border: 0;
  background: 0;

  color: ${(props) => props.theme.color.primary.v200};
  text-decoration: underline;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 8px 0 0;
  text-decoration: underline;
  text-align: left;
  padding: 0;
  &: hover {
    text-decoration: none;
  }
  &: not(: disabled) {
    cursor: pointer;
  }
  &: focus {
    outline-color: transparent;
  }

  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    text-decoration: underline;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
`;

const PaymentInfoWrapper = styled.div`
  display: flex;
  margin-top: 4px;
  flex-direction: column;

  // For desktop - devices greater than 1024px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-top: 8px;
  }

  // For desktop - devices greater than 1024px
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    flex-direction: row;
  }

  // For <= 320px
  @media (max-width: 320px) {
    margin-top: 0;
  }
`;

const PaymentDetails = styled.div`
  display: flex;

  // For devices greater than 414px
  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    align-items: center;
  }

  // For tablet desktop - devices greater than 1024px
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    &:first-of-type {
      margin-right: 26px;
    }
  }

  // For <= 320px
  @media (max-width: 320px) {
    flex-direction: column;
    margin-top: 4px;
  }
`;

const Label = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.neutral.v500};

  // For tablet desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
  }
`;

const PDValue = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.primary.v600};
  margin-left: 4px;

  // For <= 320px
  @media (max-width: 320px) {
    margin-left: 0;
  }

  // For desktop - devices greater than 1024px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    font-weight: 450;
    line-height: 27px;
  }
`;

const AppraisalsViewLinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;

  // For devices less than 340px
  @media (max-width: 340px) {
    align-items: baseline;

    & > button {
      width: 50%;
    }

    & > button:last-of-type {
      text-align: right;
    }
  }
`;

const HeaderText = styled.h2`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.color.primary.v400};

  margin: 24px 0 16px;

  &:first-of-type {
    margin-top: 16px;
  }

  // For desktop - devices greater than 1024px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    margin: 32px 0 16px;

    &:first-of-type {
      margin-top: 24px;
    }
  }
`;

const VehicleDetailsLeft = styled.div`
   display: flex;
   flex-direction: row;
   justify-content: flex-start
   margin: 0;
   padding: 0;
  
`;
const VehicleDetailsRight = styled.div`
  margin: 0;
  padding: 0;
`;

const ExCancelIconWrapper = styled.div`
  margin-top: -8px;
  margin-right: -8px;
  text-decoration: none;
  cursor: pointer !important;

  & * {
    cursor: pointer !important;
  }
`;

const Arrow = styled.svg`
  margin-right: 7px;
`;

const AppraisalShowText = styled.button`
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 14px;
  color: ${(props) => props.theme.color.primary.v200};
  border: 0;
  background: 0;
  margin: 8px 0 0;
  &: hover {
    text-decoration: none;
  }
  &: not(: disabled) {
    cursor: pointer;
  }
  &: focus {
    outline-color: transparent;
  }
`;

export const AddVehicleButtonWrapper = styled.div`
  margin-top: 0;
`;

const MFEShellWrapper = styled.div`
  display: flex;
  flex-direction: column;

  // Margin between cards
  & > *:not(${AddVehicleButtonWrapper}) {
    margin: 16px 0 0;
  }
`;

export const OVPCardWrapper = styled.div`
  margin: 16px 0 0;
`;

export {
  GarageCardWrapper,
  AlertHeader,
  Arrow,
  WarningHeader,
  VehicleDetails,
  ImageContainer,
  Image,
  VehicleInfo,
  Make,
  Model,
  Price,
  PaymentDetails,
  Label,
  PDValue,
  PaymentSchedule,
  RedirectLinkStyled,
  AppraisalsViewLinkWrapper,
  HeaderText,
  AppraisalShowText,
  PaymentInfoWrapper,
  VehicleDetailsLeft,
  VehicleDetailsRight,
  ExCancelIconWrapper,
  MFEShellWrapper,
};
